import ModuleCard from './moduleCard';
import ModuleTopicsCard from './moduleTopicsCard';
import { dsaModules } from './content';

const moduleToTagMap = {
    "Module 1": 0,
    "Module 2": 0,
    "Module 3": 0,
    "Module 4": 0,
    "Module 5": 0,
    "Module 6": 0,
    "Module 7": 0,
    "Module 8": 1,
    "Module 9": 1,
    "Module 10": 1,
    "Module 11": 2,
    "Module 12": 3,
    "Module 13": 4,
};


const ModuleList = ({ isSelectedModule, setIsSelectedModule, moduleRefs, scrollContainerRef, setActiveTag }) => {
    return (
        <div className='flex flex-wrap gap-3'>
            <div
                className='sm:h-[448px] sm:w-[554px] sm:overflow-y-scroll scrollbar-thin scrollbar-thumb-[#B8C0CC] scrollbar-track-[#E8EDFB] scrollbar-thumb-rounded-[0px] w-full'
                ref={scrollContainerRef}
            >
                {dsaModules.map((item) => (
                    <div
                        key={item.module}
                        ref={(el) => {
                            if (el) {
                                moduleRefs.current[item.module] = el;
                            } else {
                                delete moduleRefs.current[item.module];
                            }
                        }}
                        onClick={() => {
                            setActiveTag(moduleToTagMap[item.module]);
                        }}
                    >
                        <ModuleCard
                            module={item.module}
                            title={item.title}
                            videoCount={item.videoCount}
                            description={item.description}
                            topics={item.topics}
                            isSelected={isSelectedModule === item.module}
                            setIsSelected={setIsSelectedModule}
                        />
                    </div>
                ))}
            </div>
            <div className='sm:w-[554px] sm:block hidden'>
                {dsaModules.find((m) => m.module === isSelectedModule) && (
                    <ModuleTopicsCard
                        topics={dsaModules.find((m) => m.module === isSelectedModule).topics}
                    />
                )}
            </div>
        </div>
    );
};

export default ModuleList;